import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import useBuyFormStore from "../../stores/useBuyFormStore";
import {IRequestedMinutes} from "../../types/parkingOptions.type";

interface FormValues {
    email: string;
    licencePlate: string;
    requestedMinutes: IRequestedMinutes;
}

/**
 * Auto synchronization of Formik and Zustand states
 * Zustand is master, Formik is slave
 */
export const BuyZustandFormikSync: React.FC = () => {
    const { setFieldValue, values } = useFormikContext<FormValues>();
    const store = useBuyFormStore();

    useEffect(() => {
        if (store.email !== values.email) {
            setFieldValue("email", store.email, false);
        }
    }, [store.email]);

    useEffect(() => {
        if (store.licencePlate !== values.licencePlate) {
            setFieldValue("licencePlate", store.licencePlate, false);
        }
    }, [store.licencePlate]);

    useEffect(() => {
        if (store.requestedMinutes !== values.requestedMinutes) {
            setFieldValue("requestedMinutes", store.requestedMinutes, false);
        }
    }, [store.requestedMinutes]);

    return null;
};

export const ZustandField: React.FC<{
    name: "email" | "licencePlate" | "requestedMinutes";
    component?: any;
    [key: string]: any;
}> = ({ name, component: Component = "input", ...props }) => {
    const { values, handleBlur } = useFormikContext<FormValues>();
    const store = useBuyFormStore();

    const handleChange = (e: any) => {
        const value = e.target ? e.target.value : e;

        switch (name) {
            case "email":
                store.setEmail(value);
                break;
            case "licencePlate":
                store.setLicencePlate(value);
                break;
            case "requestedMinutes":
                store.setRequestedMinutes(value);
                break;
        }
    };

    return <Component name={name} value={values[name]} onChange={handleChange} onBlur={handleBlur} {...props} />;
};
